var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 21.8h-5.9V8.2C37.1 3.7 33.4 0 29 0h-13a8.3 8.3 0 0 0-8.2 8.2v13.6H1.8c-1 0-1.8.8-1.8 1.8v24.6c0 1 .8 1.8 1.8 1.8h25c1.1 0 1.9-.8 1.9-1.8s-.8-1.8-1.8-1.8H3.6v-21h37.6v21h-4.6c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8H43c1 0 1.8-.8 1.8-1.8V23.6c0-1-.8-1.8-1.8-1.8zm-31.7 0V8.2c0-2.5 2.1-4.6 4.7-4.6h12.9c2.5 0 4.6 2.1 4.6 4.6v13.6H11.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 40.6h1c.7 0 1.2-.6 1.2-1.3v-2.5c.6-.5 1-1.3 1-2.1a2.8 2.8 0 0 0-5.6 0c0 .8.4 1.6 1 2.1v2.5c0 .7.6 1.3 1.4 1.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.4426fcae.svg";
export { ForwardRef as ReactComponent };